import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import ProjectCard from "./ProjectCard";
import Skeleton from 'react-loading-skeleton';
import {
  projectHeading,
  gitHubLink,
  gitHubUsername,
  gitHubQuerry,
  projectsLength,
  icons
} from "../editable-stuff/configuration.json";

const Project = () => {
  const [projectsArray, setProjectsArray] = useState([]);

  const handleRequest = useCallback((e) => {
    axios
      .get(gitHubLink + gitHubUsername + gitHubQuerry)
      .then((response) => {
        // handle success
        // console.log(response.data.slice(0, 4));
        return setProjectsArray(response.data.slice(0, projectsLength));
      })
      .catch((error) => {
        // handle error
        return console.error(error.message);
      })
      .finally(() => {
        // always executed
      });
  }, []);

  useEffect(() => {
    handleRequest();
  }, [handleRequest]);

  return (
    <div id="projects" className="jumbotron jumbotron-fluid bg-transparent m-0">
      {
      projectsArray.length ? 
      (
        <div className="container container-fluid p-5">
          <h1 className="display-4 mb-5 text-center">{projectHeading}</h1>
          <div className="row">
            {projectsArray.map((project) => (
              <ProjectCard key={project.id} id={project.id} value={project} />
            ))}
          </div>
          <a
            href={`${icons[0].url}`}
            className="btn btn-outline-secondary btn-lg col-md-6 offset-md-3"
            role="button"
            aria-label="More projects"
            >
            MORE PROJECTS
            </a>
        </div>
      )
      :
      (
        <div className="container container-fluid p-5">
          <h1 className="display-4 mb-5 text-center">{projectHeading}</h1>
            <div className="col-md-6 offset-md-3 text-center">
              <div className="card shadow-lg p-3 mb-5 bg-white rounded">
                <Skeleton />
                <p style={{color: "red", fontSize: 20}}>Projects not found</p>
                <Skeleton count={3} />
              </div>
            </div>
        </div>
      )       
    }
    </div>
  )
}

export default Project